var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserProfileStar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7144 8.99989C11.7144 10.5113 10.6592 11.5854 9.35753 11.5854C8.05585 11.5854 7.00063 10.5113 7.00063 8.99989C7.00063 7.48848 8.05585 6.58535 9.35753 6.58535C10.6592 6.58535 11.7144 7.48848 11.7144 8.99989Z",
    stroke: "#DAAA00",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 17.6851C15.5 19.2397 13.6818 20.4999 9.5 20.4999C5.31818 20.4999 3.5 19.2397 3.5 17.6851C3.5 16.1305 6.18629 14.8702 9.5 14.8702C12.8137 14.8702 15.5 16.1305 15.5 17.6851Z",
    stroke: "#DAAA00",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 4L17.8499 5.83016L19.8532 6.07295L18.3752 7.44684L18.7634 9.42705L17 8.446L15.2366 9.42705L15.6248 7.44684L14.1468 6.07295L16.1501 5.83016L17 4Z",
    stroke: "#DAAA00",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfileStar);
export default __webpack_public_path__ + "static/media/user-profile-star.b8875eddd2a3582e51fe8bccbd783681.svg";
export { ForwardRef as ReactComponent };